import Avatar1 from '@op/assets/robots/1.svg'
import Avatar2 from '@op/assets/robots/2.svg'
import Avatar3 from '@op/assets/robots/3.svg'
import Avatar4 from '@op/assets/robots/4.svg'
import { createLazyValue } from '../../util/createLazyValue'

export const DEFAULT_AVATAR_IMAGES = createLazyValue<string[]>(() => [
	Avatar1,
	Avatar2,
	Avatar3,
	Avatar4,
])
